<template>
  <Visitas />
</template>

<script>
import Visitas from '@/components/Visitas/Visitas.vue'
export default {
  name: 'VisitasView',
  components: { Visitas }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/VisitasView.vue